export default __webpack_public_path__ + "static/media/bernygroup1a.b2dc7aa0.jpg";